module.exports = __webpack_public_path__ + "img/logo.59e3d4fc.png";